import React, { useEffect, useRef } from 'react';
import { IconContext } from 'react-icons';
import { IoMdCloseCircleOutline } from 'react-icons/io';

interface TermsDialogProps {
  openModal: boolean;
  agree: () => void;
  disagree: () => void;
  closeModal: () => void;
}

function TermsDialog({ openModal, agree, disagree, closeModal }: TermsDialogProps) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (openModal) {
      ref.current?.showModal();
    } else {
      ref.current?.close();
    }
  }, [openModal]);

  const handleAgree = (e) => {
    e?.preventDefault();
    agree();
    closeModal();
  };

  const handleDisagree = (e) => {
    e?.preventDefault();
    disagree();
    closeModal();
  };

  return (
    <dialog ref={ref} onCancel={closeModal} className="rounded-3xl">
      <div className="flex flex-col justify-between mx-auto md:max-w-4xl max-h-[500px] bg-white terms-dialog">
        {/** HEADER */}
        <div className="flex justify-between items-center p-10">
          <h2 className="text-lg md:text-4xl md:leading-[48px] font-bold">
            SYARAT DAN KETENTUAN UMUM AUTO2000
          </h2>
          <button className="self-start -mt-5" onClick={closeModal}>
            <IconContext.Provider value={{ size: '30' }}>
              <IoMdCloseCircleOutline />
            </IconContext.Provider>
          </button>
        </div>
        {/** BODY */}
        <div className="max-h-[500px] overflow-y-scroll py-4 px-10 border-t-2 custom-scrollbar text-[16px] leading-5 text-justify">
          <h3 className="text-supportiveRed my-4">KETENTUAN UMUM</h3>
          <ol className="list-decimal flex flex-col gap-y-4 px-5">
            <li>
              Selamat datang di situs resmi milik PT Astra International Tbk - Auto2000 (selanjutnya
              disebut “Perusahaan” atau “Kami”) (selanjutnya disebut dengan “Situs”). Berikut ini
              adalah Syarat dan Ketentuan yang mengatur penggunaan Situs ini (selanjutnya disebut
              dengan “Ketentuan”). Dengan mengunduh, mengakses dan/atau menggunakan Situs, anda
              setuju bahwa anda telah membaca, memahami, mengetahui, menyetujui, dan menerima
              seluruh informasi, syarat, dan ketentuan penggunaan layanan yang terdapat dalam
              Ketentuan ini. Ketentuan ini merupakan perjanjian yang sah antara Kami dan anda
              terkait tata cara dan persyaratan penggunaan Situs ini.
            </li>
            <li>
              Konten ialah seluruh informasi yang terdapat dalam Situs termasuk, informasi, data dan
              program tertulis, gambar visual atau audio.
            </li>
            <li>
              Materi ialah gambar, komentar, penilaian, maupun saran yang anda unggah di dalam
              Situs.
            </li>
            <li>
              Hak cipta atas Konten dari Situs ini adalah milik Perusahaan dan/atau diberikan
              lisensinya kepada Perusahaan oleh pihak ketiga. Konten dari Situs ini dilindungi oleh
              undang-undang hak cipta, traktat, dan peraturan perundang-undangan di negara Republik
              Indonesia dan negara terkait dimana pemilik lisensi berada. Anda dilarang untuk
              menggunakan Konten di luar ketentuan yang diperbolehkan dalam Ketentuan ini dan yang
              secara tegas oleh peraturan perundang-undangan, termasuk namun tidak terbatas kepada
              penggandaan, pendistribusian, pengubahan, penyiaran untuk umum, penggunaan kembali
              dan/atau pemindahan Konten.
            </li>
          </ol>
          Anda kapan saja dapat berhenti menggunakan Situs ini, termasuk mengajukan permintaan
          penghapusan akun (apabila anda telah melakukan pendaftaran sebagai pengguna Situs). Mohon
          diperhatikan bahwa penggunaan Situs tunduk pada Ketentuan yang Perusahaan keluarkan
          dan/atau perbaharui dari waktu ke waktu. Anda menyatakan dan menjamin bahwa anda adalah
          individu yang secara hukum berhak dan cakap untuk mengadakan dan mengikatkan diri dalam
          perjanjian berdasarkan hukum Negara Republik Indonesia. Apabila ketentuan tersebut tidak
          terpenuhi, Perusahaan berhak berdasarkan hukum untuk membatalkan setiap perjanjian yang
          dibuat dengan anda. Anda selanjutnya menyatakan dan menjamin bahwa anda memiliki hak,
          wewenang dan kapasitas untuk menggunakan Situs. Perusahaan mengumpulkan dan memproses
          informasi pribadi Anda seperti nama, alamat, surat elektronik, nomor telepon Anda ketika
          anda mendaftarkan diri pada Situs. Anda wajib untuk memberikan informasi yang akurat dan
          lengkap serta memperbarui informasi dan setuju untuk memberikan kepada Perusahaan bukti
          identitas apapun yang secara wajar Perusahaan mintakan agar Perusahaan dapat tetap
          menyediakan layanan melalui Situs secara utuh dan maksimal kepada anda. Setelah
          mendaftarkan diri pada Situs, anda akan mendapatkan suatu akun pribadi yang dapat diakses
          dengan kata sandi yang anda pilih. Anda berjanji untuk tidak menyerahkan, mengalihkan
          maupun memberikan wewenang kepada orang lain untuk menggunakan identitas anda atau
          menggunakan akun anda. Anda wajib menjaga kerahasiaan kata sandi akun anda dan setiap
          identifikasi yang Perusahaan berikan kepada atas akun atau identitas pribadi anda. Dalam
          hal terjadi pengungkapan kata sandi atas akun anda dengan cara apapun yang terjadi bukan
          atas kesalahan Perusahaan dan mengakibatkan penggunaan yang tidak sah dan/atau tanpa
          kewenangan atas akun anda, transaksi maupun pesanan yang terjadi dalam Situs tetap
          dianggap sebagai transaksi yang sah kecuali anda memberitahu Perusahaan sebelumnya. Anda
          wajib melaporkan kepada Perusahaan bila anda kehilangan kendali atas akun anda. Anda
          bertanggung jawab atas setiap penggunaan akun Situs anda meskipun jika Akun tersebut telah
          disalahgunakan oleh pihak lain. Anda dapat melakukan pengunggahan informasi, foto, video,
          konten, penilaian, komentar dalam fitur-fitur tertentu yang terdapat dalam Situs, dimana
          hasil unggahan anda akan dapat dikonsumsi oleh pengguna Situs lainnya. Anda dilarang untuk
          melakukan pengunggahan yang mengandung unsur suku, agama, ras dan antargolongan (“SARA”),
          pornografi, pelanggaran hak kekayaan intelektual dan/atau copyright. Perusahaan berhak
          untuk melakukan penghapusan atau pemblokiran atas hasil unggahan anda apabila unggahan
          tersebut melanggar Ketentuan. Anda tidak diperkenankan untuk membahayakan,
          menyalahgunakan, mengubah atau memodifikasi Situs dengan cara apapun. Perusahaan berhak
          untuk menghentikan penggunaan atas akun Situs anda lebih lanjut jika anda menggunakan
          Situs tanpa mematuhi Ketentuan. Anda hanya diizinkan untuk menggunakan Situs ini untuk
          tujuan mempergunakan layanan yang disediakan dalam Situs ini dan keperluan lain sesuai
          peraturan perundang-undangan yang berlaku. Untuk lebih tegasnya, anda dilarang untuk
          melakukan penggalian data informasi Perusahaan atau informasi lainnya yang memiliki
          keterkaitan dengan Situs. Anda tidak dapat mempergunakan Situs ini untuk melakukan
          penipuan dalam bentuk apapun dan/atau membuat ketidaknyamanan terhadap pihak lain maupun
          pihak yang menyediakan layanan dalam Situs ini. Segala informasi yang anda dapatkan
          terkait penggunaan layanan dalam Situs ini tidak akan disalahgunakan oleh anda. Anda harus
          menjaga kerahasiaan dan tidak akan menyalahgunakan informasi yang anda terima dari
          penggunaan Situs. Anda dilarang menggunakan Situs untuk hal-hal yang dilarang berdasarkan
          hukum dan peraturan undang-undang yang berlaku. Perusahaan bekerja sama dengan pihak
          ketiga (“Mitra Perusahaan”) untuk mengembangkan, menambah dan/atau meningkatkan fitur
          serta fungsi dalam Situs dan/atau menyediakan layanan termasuk layanan jual beli mobil
          bekas.
        </div>
        {/** FOOTER */}
        <div className="flex justify-center items-center px-10 py-8 gap-4">
          <button
            className="bg-white flex justify-center items-center border-2 rounded-full border-supportiveRed text-supportiveRed px-12 py-2 text-md font-semibold"
            onClick={handleAgree}
          >
            SETUJU
          </button>
          <button
            className="bg-white flex justify-center items-center border-2 rounded-full border-reliableBlack text-reliableBlack px-12 py-2 text-md font-semibold"
            onClick={handleDisagree}
          >
            BATAL
          </button>
        </div>
      </div>
    </dialog>
  );
}

export default TermsDialog;
